var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-form-group",
        { attrs: { label: "Period", "label-for": "category" } },
        [
          _c("b-form-input", {
            attrs: {
              id: "category",
              type: "text",
              placeholder: "Enter Name",
              required: "",
            },
            model: {
              value: _vm.category,
              callback: function ($$v) {
                _vm.category = $$v
              },
              expression: "category",
            },
          }),
        ],
        1
      ),
      _vm._l(_vm.cards, function (card, cardIndex) {
        return _c(
          "div",
          { key: cardIndex, staticClass: "mb-3" },
          [
            _c(
              "b-card",
              [
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      { attrs: { cols: "12", md: "6", lg: "2" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: { label: "Name", "label-for": "name-input" },
                          },
                          [
                            _c("b-form-input", {
                              attrs: {
                                id: "name-input",
                                type: "text",
                                placeholder: "Enter Name",
                                required: "",
                              },
                              model: {
                                value: card.columns[0].name,
                                callback: function ($$v) {
                                  _vm.$set(card.columns[0], "name", $$v)
                                },
                                expression: "card.columns[0].name",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._l(card.columns.slice(1, 5), function (col, colIndex) {
                      return _c(
                        "b-col",
                        {
                          key: colIndex,
                          staticClass: "mb-2",
                          attrs: { cols: "12", md: "6", lg: "2" },
                        },
                        [
                          _c("div", [
                            _c("strong", [_vm._v("Q" + _vm._s(colIndex + 1))]),
                          ]),
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "Budget",
                                "label-for": "budget-input",
                              },
                            },
                            [
                              _c("b-form-input", {
                                attrs: {
                                  id: "budget-input",
                                  type: "number",
                                  placeholder: "Enter Budget",
                                  required: "",
                                },
                                on: {
                                  input: function ($event) {
                                    return _vm.updateTotal(cardIndex)
                                  },
                                },
                                model: {
                                  value: col.budget,
                                  callback: function ($$v) {
                                    _vm.$set(col, "budget", $$v)
                                  },
                                  expression: "col.budget",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "Actual",
                                "label-for": "actual-input",
                              },
                            },
                            [
                              _c("b-form-input", {
                                attrs: {
                                  id: "actual-input",
                                  type: "number",
                                  placeholder: "Enter Actual",
                                  required: "",
                                },
                                on: {
                                  input: function ($event) {
                                    return _vm.updateTotal(cardIndex)
                                  },
                                },
                                model: {
                                  value: col.actual,
                                  callback: function ($$v) {
                                    _vm.$set(col, "actual", $$v)
                                  },
                                  expression: "col.actual",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    }),
                    _c(
                      "b-col",
                      { attrs: { cols: "12", md: "6", lg: "2" } },
                      [
                        _c("div", [_c("strong", [_vm._v("Y")])]),
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              label: "Budget",
                              "label-for": "y-budget-input",
                            },
                          },
                          [
                            _c("b-form-input", {
                              attrs: {
                                id: "y-budget-input",
                                type: "number",
                                readonly: "",
                              },
                              model: {
                                value: card.columns[5].budget,
                                callback: function ($$v) {
                                  _vm.$set(card.columns[5], "budget", $$v)
                                },
                                expression: "card.columns[5].budget",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              label: "Actual",
                              "label-for": "y-actual-input",
                            },
                          },
                          [
                            _c("b-form-input", {
                              attrs: {
                                id: "y-actual-input",
                                type: "number",
                                readonly: "",
                              },
                              model: {
                                value: card.columns[5].actual,
                                callback: function ($$v) {
                                  _vm.$set(card.columns[5], "actual", $$v)
                                },
                                expression: "card.columns[5].actual",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { cols: "12", md: "6", lg: "2" } },
                      [
                        _c(
                          "b-button",
                          {
                            staticClass: "mt-4",
                            attrs: { variant: "danger", block: "" },
                            on: {
                              click: function ($event) {
                                return _vm.deleteCard(cardIndex)
                              },
                            },
                          },
                          [_vm._v(" Remove ")]
                        ),
                      ],
                      1
                    ),
                  ],
                  2
                ),
              ],
              1
            ),
          ],
          1
        )
      }),
      _c(
        "div",
        { staticClass: "text-right mt-3" },
        [
          _c(
            "b-button",
            { attrs: { variant: "primary" }, on: { click: _vm.addCard } },
            [_vm._v("Add")]
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "text-right mt-3" },
        [
          _c(
            "b-button",
            { attrs: { variant: "primary" }, on: { click: _vm.submitBudget } },
            [_vm._v("Update")]
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }